import { connect } from 'react-redux';

import View from './RecommendedTargetAmountChartView';
import MobileView from '../MobileRecommendedTargetAmountChart/MobileRecommendedTargetAmountChartView';
import {
  nullableChartDataSelector,
  loadingSelector,
  showLoadingSelector,
} from './RecommendedTargetAmountChartSelector';
import { fetchData, receiveData } from './RecommendedTargetAmountChartActions';
import { goalId as goalIdSelector } from '../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';

const mapStateToProps = (state, ownProps) => ({
  goalId: ownProps.goalId || goalIdSelector(state, ownProps),
  chartData: nullableChartDataSelector(state, ownProps),
  loading: loadingSelector(state, ownProps),
  showLoading: showLoadingSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  fetchData: (goalId, fpId, clientId, showLoading = false) => {
    dispatch(fetchData(goalId, fpId, clientId, showLoading));
  },
  receiveData: (data, clientId) => {
    dispatch(receiveData(data, clientId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

export const MobileRecommendedTargetAmountChart = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileView);
